import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const clientUserBranchAccessSchema = z.object({
  user: optionSchema,
  branch_hierarchy_for_user_access: optionSchema,
});

export type ClientUserBranchAccessValidationSchema = z.infer<typeof clientUserBranchAccessSchema>;
